<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right course-attendance-page">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <template slot="buttonSlot">
          <el-form-item>
            <el-button type="primary" plain icon="el-icon-document" @click="goDutyDeductionPage">扣分明细</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" icon="el-icon-download" @click="exportAttendanceStats">导出</el-button>
          </el-form-item>
        </template>
      </toolbar>

      <el-card class="table-card" shadow="never" :body-style="{ padding: '0', display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }">
        <div slot="header" class="card-header">
          <span class="title">节次统计</span>
        </div>

        <div class="table-card-body">
          <div class="tbl-scroll-host" ref="tableScrollWrap">
            <el-table height="100%" :data="paginatedLessons" stripe style="width: 100%" v-loading="listLoading"
              class="custom-tbl">
          <el-table-column type="index" label="#" width="52" align="center" :index="lessonIndexMethod"></el-table-column>
          <el-table-column prop="name" label="节次" width="72" align="center"></el-table-column>
          <el-table-column label="时间" width="128" align="center">
            <template slot-scope="scope">{{
              (scope.row.StartTime || "") +
              (scope.row.EndTime ? " - " + scope.row.EndTime : "")
            }}</template>
          </el-table-column>
          <el-table-column label="课程 / 教师" min-width="170">
            <template slot-scope="scope">
              <div class="course-teacher-cell">
                <div class="course-teacher-course" :title="scope.row.CourseName || '-'">
                  {{ scope.row.CourseName || '-' }}
                </div>
                <div class="course-teacher-teacher" :title="scope.row.TeacherName || '-'">
                  {{ scope.row.TeacherName || '-' }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="点名状态" width="150" align="center">
            <template slot-scope="scope">
              <!-- 未点名但已复核：优先展示已复核，避免误以为仍可补点。最后更新：2026-11-04 -->
              <el-tooltip
                v-if="scope.row.isReviewed && !scope.row.isMarked"
                :content="formatReviewedTooltip(scope.row)"
                placement="top"
              >
                <span style="color:#409EFF">已复核</span>
              </el-tooltip>
              <el-tooltip
                v-else-if="scope.row.isMarked && scope.row.lastMarkedTime"
                :content="'点名时间：' + formatDate(scope.row.lastMarkedTime)"
                placement="top"
              >
                <span :style="{ color: scope.row.isReviewed ? '#409EFF' : '#67C23A' }">
                  {{ formatMarkStatusText(scope.row) }}
                </span>
              </el-tooltip>
              <span v-else-if="scope.row.isMarked" :style="{ color: scope.row.isReviewed ? '#409EFF' : '#67C23A' }">
                {{ formatMarkStatusText(scope.row) }}
              </span>
              <span v-else style="color:#F56C6C">未点名</span>
            </template>
          </el-table-column>
          <el-table-column label="教师签到" width="112" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.teacherCheckedIn" style="color:#67C23A">
                已签到{{ scope.row.teacherCheckInTime ? ' ' + formatTimeOnly(scope.row.teacherCheckInTime) : '' }}
              </span>
              <span v-else style="color:#F56C6C">未签到</span>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="总人数" width="72" align="center"></el-table-column>
          <el-table-column label="缺勤" width="62" align="center">
            <template slot-scope="scope">{{
              (scope.row.counts && scope.row.counts.miss) || 0
            }}</template>
          </el-table-column>
          <el-table-column label="正常出勤" width="78" align="center">
            <template slot-scope="scope">{{
              (scope.row.counts && scope.row.counts.normal) || 0
            }}</template>
          </el-table-column>
          <el-table-column label="迟/退" width="62" align="center">
            <template slot-scope="scope">{{
              (scope.row.counts && scope.row.counts.lateOrEarlyLeave) || 0
            }}</template>
          </el-table-column>
          <el-table-column label="请假" width="62" align="center">
            <template slot-scope="scope">{{
              (scope.row.counts && scope.row.counts.leave) || 0
            }}</template>
          </el-table-column>
          <el-table-column label="其他" width="62" align="center">
            <template slot-scope="scope">{{
              (scope.row.counts && scope.row.counts.other) || 0
            }}</template>
          </el-table-column>
          <el-table-column label="操作" width="104" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="showDetails(scope.row)">查看明细</el-button>
            </template>
          </el-table-column>
        </el-table>
          </div>
          <div v-if="total > 0" class="pagination-container">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="page"
              :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total"
              @current-change="onPageChange" @size-change="handleLessonSizeChange"></el-pagination>
          </div>
        </div>
      </el-card>

      <!-- 明细弹窗：列宽按内容分配，避免姓名/来源挤、时间列过宽。最后修改：2026-10-20 -->
      <el-dialog :title="detailTitle" :visible.sync="detailDialogVisible" width="980px" center
        @close="onDetailDialogClose">
        <div class="detail-toolbar">
          <el-input
            v-model="detailKeyword"
            clearable
            size="small"
            placeholder="搜索学生姓名"
            prefix-icon="el-icon-search"
            class="detail-search-input"
            @input="onDetailSearchInput"
            @clear="onDetailSearchInput"
          />
          <el-select
            v-model="detailStatusFilter"
            clearable
            size="small"
            placeholder="按状态筛选"
            class="detail-status-select"
            @change="onDetailSearchInput"
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="正常出勤" value="normal"></el-option>
            <el-option label="迟/退" value="lateEarly"></el-option>
            <el-option label="缺勤" value="0"></el-option>
            <el-option label="请假" value="2"></el-option>
            <el-option label="其他" value="3"></el-option>
          </el-select>
          <el-button
            type="primary"
            plain
            size="small"
            icon="el-icon-search"
            @click="onDetailSearchInput"
          >查询</el-button>
        </div>
        <el-table :data="detailDisplayedStudents" height="450" style="width: 100%">
          <el-table-column prop="Name" label="姓名" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="Status" label="状态" width="168" align="center">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :content="scope.row.StateText || statusLabel(scope.row.Status, scope.row.IsLate, scope.row.IsEarlyLeave)"
              >
                <el-tag :type="statusTagType(scope.row.Status, scope.row.IsLate, scope.row.IsEarlyLeave)" disable-transitions>{{
                  scope.row.StateText || statusLabel(scope.row.Status, scope.row.IsLate, scope.row.IsEarlyLeave)
                }}</el-tag>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="来源 / 归属" min-width="148" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="detail-cell-two-lines">
                <div :title="sourceLabel(scope.row.Source)">{{ sourceLabel(scope.row.Source) || "-" }}</div>
                <div class="detail-cell-secondary" :title="stateOwnerLabel(scope.row.StateOwner)">
                  {{ stateOwnerLabel(scope.row.StateOwner) || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型 / 执行者" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="detail-cell-two-lines">
                <div :title="actionTypeLabel(scope.row.ActionType)">{{ actionTypeLabel(scope.row.ActionType) || "-" }}</div>
                <div class="detail-cell-secondary" :title="scope.row.ActionActorName">
                  {{ scope.row.ActionActorName || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="时间 / 备注" width="168" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="detail-cell-two-lines">
                <div>{{ scope.row.ActionTime ? formatDate(scope.row.ActionTime) : "-" }}</div>
                <div class="detail-cell-secondary" :title="scope.row.Remark">
                  {{ scope.row.Remark || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="动作明细" width="96" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.RecordId && String(scope.row.RecordId) !== '0'" size="mini" type="text"
                @click="openActionDialog(scope.row.RecordId, scope.row.Name)">查看动作</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page.sync="detailPage"
            :page-size="detailPageSize"
            :total="detailFilteredStudents.length"
            style="float: right"
            @current-change="handleDetailPageChange"
          />
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 动作明细：加宽以容纳「出勤·迟到·早退」等长状态。最后修改：2026-10-20 -->
      <el-dialog :title="actionTitle" :visible.sync="actionDialogVisible" width="760px" center
        @close="actionDialogVisible = false">
        <el-table :data="actionList" v-loading="actionLoading" max-height="360" style="width: 100%">
          <el-table-column label="动作 / 状态" width="176">
            <template slot-scope="scope">
              <div class="detail-cell-two-lines">
                <div :title="actionTypeLabel(scope.row.ActionType)">
                  {{ actionTypeLabel(scope.row.ActionType) || "-" }}
                </div>
                <div class="detail-cell-secondary">
                  <el-tooltip
                    effect="dark"
                    placement="top"
                    :content="statusLabel(scope.row.ResultState, scope.row.IsLate, scope.row.IsEarlyLeave)"
                  >
                    <el-tag
                      size="mini"
                      :type="statusTagType(scope.row.ResultState, scope.row.IsLate, scope.row.IsEarlyLeave)"
                      disable-transitions
                    >
                      {{ statusLabel(scope.row.ResultState, scope.row.IsLate, scope.row.IsEarlyLeave) }}
                    </el-tag>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="时间 / 角色" width="168">
            <template slot-scope="scope">
              <div class="detail-cell-two-lines">
                <div>{{ scope.row.ActionTime ? formatDate(scope.row.ActionTime) : "-" }}</div>
                <div class="detail-cell-secondary" :title="stateOwnerLabel(scope.row.ActorRole)">
                  {{ stateOwnerLabel(scope.row.ActorRole) || scope.row.ActorRole || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="执行者 / 备注" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="detail-cell-two-lines">
                <div :title="scope.row.ActorName">{{ scope.row.ActorName || "-" }}</div>
                <div class="detail-cell-secondary" :title="scope.row.Remark">
                  {{ scope.row.Remark || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="actionDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import Toolbar from "@/components/Toolbar";
import DepartmentPane from "@/components/DepartmentPane";
import { getButtonList } from "@/promissionRouter";
import {
  getAttendanceStatsByClass,
  getAttendanceStatsByClassExport,
  getRollCallActionsByRecord,
} from '../../api/modules/schedule-course';

export default {
  name: "CourseAttendanceStatus",
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      buttonList: [],
      searchList: [
        {
          label: "日期",
          key: "date",
          type: "date",
        },
      ],

      courseList: [
        { Id: 1, Name: "语文" },
        { Id: 2, Name: "数学" },
      ],
      selectedCourse: null,
      departmentId: null,

      listLoading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      lessons: [],
      // 明细弹窗相关
      detailDialogVisible: false,
      detailStudents: [],
      detailTitle: "",
      detailPage: 1,
      detailPageSize: 10,
      detailKeyword: "",
      detailStatusFilter: "",
      // 动作明细弹窗
      actionDialogVisible: false,
      actionList: [],
      actionLoading: false,
      actionTitle: "",
    };
  },
  methods: {
    /** 点名状态文案（含已复核）。创建于 2026-11-04 */
    formatMarkStatusText(row) {
      if (!row) return '未点名'
      if (row.isReviewed && !row.isMarked) return '已复核'
      if (!row.isMarked) return '未点名'
      if (row.isReviewed) {
        return row.isMakeup ? '已点名【补点·已复核】' : '已点名【已复核】'
      }
      return row.isMakeup ? '已点名【补点】' : '已点名'
    },
    /** 已复核悬停提示。创建于 2026-11-04 */
    formatReviewedTooltip(row) {
      if (!row) return '班主任已复核'
      const parts = []
      if (row.lastReviewedHeadTeacherName) parts.push('复核人：' + row.lastReviewedHeadTeacherName)
      if (row.lastReviewedTime) parts.push('复核时间：' + this.formatDate(row.lastReviewedTime))
      return parts.length ? parts.join('；') : '班主任已复核'
    },
    formatDate(v) {
      if (!v) return "";
      try {
        const date = new Date(v);
        if (Number.isNaN(date.getTime())) return v;
        const pad = value => String(value).padStart(2, "0");
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} `
          + `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
      } catch (e) {
        return v;
      }
    },
    formatTimeOnly(v) {
      if (!v) return "";
      try {
        const d = new Date(v);
        const h = d.getHours().toString().padStart(2, "0");
        const m = d.getMinutes().toString().padStart(2, "0");
        return `${h}:${m}`;
      } catch (e) {
        return v;
      }
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == "object") {
        this.filters = item.search;
      } else {
        this.filters = {
          key: item.search,
        };
      }
      this[item.Func].apply(this, item);
    },
    treeNodeClick(node) {
      console.log("选择部门节点", node);
      // 支持不同组件发出的节点结构：{ value } 或 { Id } 或 { id }
      let deptId = null;
      if (!node) deptId = null;
      else if (node.value !== undefined) deptId = node.value;
      else if (node.Id !== undefined) deptId = node.Id;
      else if (node.id !== undefined) deptId = node.id;

      this.departmentId = deptId;

      // 总平台限制：阻止统计并给出错误提示
      if (this.departmentId == 0) {
        this.$message({
          message: '抱歉，暂不支持总平台级别的数据统计，请选择具体的学校。',
          type: 'error'
        });
        // 清空列表
        this.lessons = [];
        this.total = 0;
        return;
      }

      this.page = 1;
      // 根据部门过滤学生/班级
      this.loadList();
    },

    handleQuery() {
      this.page = 1;
      this.loadList();
    },

    /**
     * 导出当前班级和日期的课程考勤统计。创建于 2026-10-20
     */
    async exportAttendanceStats() {
      if (!this.departmentId) {
        this.$message({ message: "请先选择班级", type: "warning" });
        return;
      }
      try {
        const response = await getAttendanceStatsByClassExport({
          departmentId: this.departmentId,
          date: this.filters.date || "",
        });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `课程考勤统计_${this.filters.date || ""}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("课程考勤统计导出失败:", error);
        this.$message({ message: "导出失败", type: "error" });
      }
    },

    /**
     * 跳转课堂考勤迟到/早退扣分明细页，带入当前班级与日期。创建于 2026-10-20
     */
    goDutyDeductionPage() {
      const date =
        (this.filters && this.filters.date) ||
        this.currentDate ||
        "";
      const query = {};
      if (this.departmentId) query.departmentId = this.departmentId;
      const activeSchoolId =
        (this.$store && this.$store.state && this.$store.state.activeSchoolId) ||
        window.localStorage.getItem("activeSchoolId");
      if (activeSchoolId) query.schoolId = activeSchoolId;
      if (date) {
        query.date = date;
        query.startDate = date;
        query.endDate = date;
      }
      // 使用一次性上下文传递筛选条件，避免 query 改变 fullPath 后生成重复页签。
      sessionStorage.setItem(
        "courseAttendanceDutyDeductionContext",
        JSON.stringify({
          schoolId: query.schoolId || "",
          departmentId: query.departmentId || "",
          date: query.date || "",
          startDate: query.startDate || "",
          endDate: query.endDate || "",
        }),
      );
      this.$router.replace({
        path: "/Schedule/CourseAttendanceDutyDeduction",
      });
    },

    loadList() {
      this.listLoading = true;

      const params = {
        ...this.filters,
        courseId: this.selectedCourse ? this.selectedCourse.Id : null,
        departmentId: this.departmentId || null,
      };

      getAttendanceStatsByClass(params)
        .then((res) => {
          // 本项目中大多数接口返回结构为 axios response，数据在 res.data
          if (
            !res ||
            !res.data ||
            !res.data.success ||
            !Array.isArray(res.data.response)
          ) {
            this.lessons = [];
            this.total = 0;
            return;
          }

          const resp = res.data.response;

          const arr = resp.map((item) => {
            const students = (item.Details || []).map((d, idx) => ({
              Id: d.UserId,
              StudentNo: "",
              Name: d.UserName,
              Status: d.CurrentState,
              IsLate: !!d.IsLate,
              IsEarlyLeave: !!d.IsEarlyLeave,
              StateText: d.StateText,
              Source: d.Source,
              StateOwner: d.StateOwner,
              RecordId: d.RecordId,
              Remark: d.Remark,
              // 新增后端返回字段
              ActionType: d.ActionType,
              ActionTime: d.ActionTime,
              ActionActorRole: d.ActionActorRole,
              ActionActorId: d.ActionActorId,
              ActionActorName: d.ActionActorName,
            }));

            return {
              name: `第${item.ClassNo}节`,
              students: students,
              total: item.Total || students.length,
              present: item.Actual || 0,
              counts: {
                miss: item.Miss || 0,
                normal: item.Actual || 0,
                lateOrEarlyLeave: item.LateOrEarlyLeave || 0,
                leave: item.Leave || 0,
                other: item.Other || 0,
              },
              StartTime: item.StartTime,
              EndTime: item.EndTime,
              CourseId: item.CourseId,
              CourseName: item.CourseName,
              TeacherInfoId: item.TeacherInfoId,
              TeacherName: item.TeacherName,
              isMarked: item.IsMarked || false,
              isMakeup: item.IsMakeup || false,
              lastMarkedTime: item.LastMarkedTime,
              isReviewed: item.IsReviewed || false,
              lastReviewedTime: item.LastReviewedTime,
              lastReviewedHeadTeacherName: item.LastReviewedHeadTeacherName || '',
              teacherCheckedIn: item.TeacherCheckedIn || false,
              teacherCheckInTime: item.TeacherCheckInTime,
              teacherCheckInType: item.TeacherCheckInType,
            };
          });

          this.lessons = arr;
          this.total = arr.length;
          if (this.page > 1 && (this.page - 1) * this.pageSize >= this.total) {
            this.page = 1;
          }
        })
        .catch((err) => {
          console.error("getAttendanceStatsByClass error", err);
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    setStatus(row, status) {
      if (!row) return;
      this.$set(row, "Status", status);
    },
    statusLabel(status, isLate, isEarlyLeave) {
      // 数值枚举映射为中文；正常时可附带迟到/早退标签
      if (status === 0) return "缺勤";
      if (status === 2) return "请假";
      if (status === 3) return "其他";
      if (status === 1) {
        if (isLate && isEarlyLeave) return "出勤 · 迟到 · 早退";
        if (isLate) return "出勤 · 迟到";
        if (isEarlyLeave) return "出勤 · 早退";
        return "出勤";
      }
      return "未记录";
    },
    statusTagType(status, isLate, isEarlyLeave) {
      if (status === 1 && (isLate || isEarlyLeave)) return "warning";
      if (status === 1) return "success";
      if (status === 2) return "info";
      if (status === 0) return "danger";
      return "";
    },
    sourceLabel(src) {
      const s =
        src === null || src === undefined
          ? ""
          : String(src).trim().toLowerCase();
      if (!s) return "";
      switch (s) {
        case "leaverequest":
          return "请假单";
        case "agentleave":
          return "代请假";
        case "prevperiodfallback":
          return "回退到上节记录";
        case "firstperiodfallback":
          return "回退自第一节记录";
        case "gatefallback":
          return "门禁回退";
        case "orgevent":
          return "校历事件";
        case "dormitory":
          return "住校学生";
        case "cplatecheckin":
          return "班牌打卡";
        case "specialcoursefallback":
          return "特殊课程回退";
        case "none":
          return "";
        default:
          return src;
      }
    },
    stateOwnerLabel(owner) {
      const o =
        owner === null || owner === undefined
          ? ""
          : String(owner).trim().toLowerCase();
      if (!o) return "未知";
      switch (o) {
        case "teacher":
          return "任教教师";
        case "headteacher":
          return "班主任";
        case "system":
          return "系统";
        case "mass":
          return "社团";
        default:
          return owner;
      }
    },
    actionTypeLabel(t) {
      const v =
        t === null || t === undefined ? "" : String(t).trim().toLowerCase();
      if (!v) return "";
      switch (v) {
        case "mark":
          return "点名";
        case "review":
          return "复核";
        case "makeup":
          return "补点";
        case "import":
          return "导入";
        case "auto":
          return "系统自动";
        default:
          return t;
      }
    },
    onPageChange(p) {
      this.page = p;
    },
    handleLessonSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
    },
    /** 分页后的序号（跨页连续） */
    lessonIndexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1;
    },
    /** 打开节次学生明细：重置搜索与分页到第 1 页 */
    showDetails(row) {
      this.detailStudents = row && row.students ? row.students : [];
      this.detailTitle = row && row.name ? `${row.name} 学生明细` : "学生明细";
      this.detailKeyword = "";
      this.detailStatusFilter = "";
      this.detailPage = 1;
      this.detailDialogVisible = true;
    },
    /** 关闭明细弹窗时清空筛选条件 */
    onDetailDialogClose() {
      this.detailDialogVisible = false;
      this.detailKeyword = "";
      this.detailStatusFilter = "";
      this.detailPage = 1;
    },
    /** 明细筛选条件变更时回到第 1 页 */
    onDetailSearchInput() {
      this.detailPage = 1;
    },
    openActionDialog(recordId, studentName) {
      if (!recordId) {
        this.$message({ message: "无可用记录Id", type: "warning" });
        return;
      }
      this.actionTitle = studentName ? `${studentName} 动作明细` : "动作明细";
      this.actionLoading = true;
      this.actionList = [];
      getRollCallActionsByRecord({ recordId: recordId })
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.success &&
            Array.isArray(res.data.response)
          ) {
            this.actionList = res.data.response;
          } else {
            this.actionList = [];
            this.$message({
              message: (res && res.data && res.data.msg) || "未获取到动作明细",
              type: "info",
            });
          }
          this.actionDialogVisible = true;
        })
        .catch((err) => {
          console.error("getRollCallActionsByRecord error", err);
          this.$message({ message: "查询动作明细失败", type: "error" });
        })
        .finally(() => {
          this.actionLoading = false;
        });
    },
    handleDetailPageChange(p) {
      this.detailPage = p;
    },
  },
  computed: {
    paginatedLessons() {
      const start = (this.page - 1) * this.pageSize;
      return (this.lessons || []).slice(start, start + this.pageSize);
    },
    /** 按姓名和状态过滤后的明细列表 */
    detailFilteredStudents() {
      const kw = (this.detailKeyword || "").trim().toLowerCase();
      const statusFilter = this.detailStatusFilter;
      const list = (this.detailStudents || []).filter((student) => {
        if (statusFilter === "normal") {
          return student.Status === 1 && !student.IsLate && !student.IsEarlyLeave;
        }
        if (statusFilter === "lateEarly") {
          return student.Status === 1 && (student.IsLate || student.IsEarlyLeave);
        }
        if (statusFilter === "0" || statusFilter === "2" || statusFilter === "3") {
          return String(student.Status) === statusFilter;
        }
        return true;
      });
      if (!kw) return list;
      return list.filter((student) =>
        String(student.Name || "")
          .toLowerCase()
          .includes(kw),
      );
    },
    detailDisplayedStudents() {
      const list = this.detailFilteredStudents;
      const start = (this.detailPage - 1) * this.detailPageSize;
      return list.slice(start, start + this.detailPageSize);
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.course-attendance-page {
  overflow: hidden !important;
}

.course-attendance-page .table-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.course-attendance-page .table-card ::v-deep .el-card__header {
  flex-shrink: 0;
  padding: 4px 0 10px;
  border-bottom: 0;
  background: transparent;
}

.course-attendance-page .table-card-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e8edf5;
  border-radius: 8px;
  background: #fff;
}

.course-attendance-page .tbl-scroll-host {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.course-attendance-page .tbl-scroll-host ::v-deep .el-table {
  height: 100% !important;
}

.course-attendance-page .card-header .title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  border-left: 3px solid var(--btn-primary, #2563eb);
  padding-left: 10px;
  line-height: 1.2;
}

.course-teacher-cell {
  line-height: 1.35;
  padding: 2px 0;
}

.course-teacher-course,
.course-teacher-teacher {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.course-teacher-course {
  color: #334155;
}

.course-teacher-teacher {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.course-attendance-page .pagination-container {
  flex-shrink: 0;
  padding: 10px 16px 12px;
  text-align: right;
  border-top: 1px solid #eef1f6;
}

.course-attendance-page .pagination-container ::v-deep .el-pagination {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  row-gap: 6px;
}

.detail-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.detail-search-input {
  width: 220px;
}

.detail-status-select {
  width: 140px;
}

.detail-toolbar .el-button {
  margin-left: 0;
}

.course-attendance-page ::v-deep .detail-toolbar .el-input__inner,
.course-attendance-page ::v-deep .detail-toolbar .el-select .el-input__inner {
  border-radius: 6px;
}

.course-attendance-page ::v-deep .detail-toolbar .el-tag {
  white-space: nowrap;
}

.detail-cell-two-lines {
  line-height: 1.35;
  overflow: hidden;
}

.detail-cell-two-lines > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-cell-secondary {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

@media screen and (max-width: 900px) {
  .detail-toolbar {
    flex-wrap: wrap;
  }

  .detail-search-input {
    width: 200px;
  }
}
</style>
